import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from "recharts";
import THEME from "../../../theme";
import { fs } from "../utils/styles";

function KategorieChart({ daten, farbe }) {
  const top = daten.slice(0, 6).map(k => ({ name: k.kategorie, betrag: Math.abs(k.betrag) }));
  if (top.length === 0) return <p style={{ color: THEME.colors.textMuted, fontSize: THEME.fontSize.sm }}>Keine Daten im Zeitraum.</p>;
  return (
    <ResponsiveContainer width="100%" height={Math.max(120, top.length * 34)}>
      <BarChart data={top} layout="vertical" margin={{ left: 10, right: 20 }}>
        <XAxis type="number" hide />
        <YAxis type="category" dataKey="name" stroke={THEME.colors.textMuted} fontSize={12} width={140} />
        <Tooltip contentStyle={{ background: THEME.colors.surface, border: `1px solid ${THEME.colors.border}`, color: THEME.colors.text }} formatter={(v) => `${v.toFixed(2)} €`} />
        <Bar dataKey="betrag" radius={[0, 4, 4, 0]}>
          {top.map((_, i) => <Cell key={i} fill={farbe} />)}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}

export default function KategorienUebersicht({ einnahmenNachKategorie, ausgabenNachKategorie }) {
  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))", gap: 20, marginBottom: 20 }}>
      <div style={fs.karte}>
        <h3 style={{ color: THEME.colors.text, marginTop: 0 }}>Größte Einnahmen</h3>
        <KategorieChart daten={einnahmenNachKategorie} farbe={THEME.colors.success} />
      </div>
      <div style={fs.karte}>
        <h3 style={{ color: THEME.colors.text, marginTop: 0 }}>Größte Ausgaben</h3>
        <KategorieChart daten={ausgabenNachKategorie} farbe={THEME.colors.danger} />
      </div>
    </div>
  );
}
